import { combineReducers } from 'redux';
import devices from './devices';
import gps from './gps';
import simcards from './simcards';
import filters from './filters';

export default combineReducers({
    devices,
    gps,
    simcards,
    filters
});
